import { useEffect } from 'react';

/**
 * Injects a <script type="application/ld+json"> tag keyed by id, so repeated
 * calls replace rather than stack and it's removed on unmount. Same
 * client-side-only caveat as useTitle — the prerender script is what actually
 * makes a page's content visible to a crawler that doesn't run JS; this is a
 * secondary enhancement for engines that do.
 */
export function useJsonLd(id: string, data: object) {
  useEffect(() => {
    let tag = document.getElementById(id) as HTMLScriptElement | null;
    if (!tag) {
      tag = document.createElement('script');
      tag.id = id;
      tag.type = 'application/ld+json';
      document.head.appendChild(tag);
    }
    tag.textContent = JSON.stringify(data);
    return () => {
      tag?.remove();
    };
  }, [id, data]);
}
